"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Feed = void 0;
var create_entity_1 = require("../../utils/create-entity");
var graphql_1 = require("../../utils/graphql");
var feed_details_1 = require("../../components/entities/feed-details");
exports.Feed = {
  name: 'Feed',
  label: 'Feed',
  pluralLabel: 'Feeds',
  autoRoutes: ['details', 'create', 'update', 'list'],
  groupName: 'Library',
  useSlices: true,
  details: {
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      description { id text }\n      feedEntries { ...EntityValueFields published }\n\n      challenges { ...EntityValueFields }\n      keyIssues { ...EntityValueFields }\n      trends { ...EntityValueFields }\n      topics { ...EntityValueFields }\n      subTopics { ...EntityValueFields }\n      sdgs { ...EntityValueFields }\n\n    "], ["\n      description { id text }\n      feedEntries { ...EntityValueFields published }\n\n      challenges { ...EntityValueFields }\n      keyIssues { ...EntityValueFields }\n      trends { ...EntityValueFields }\n      topics { ...EntityValueFields }\n      subTopics { ...EntityValueFields }\n      sdgs { ...EntityValueFields }\n\n    "])))
  },
  components: {
    details: feed_details_1.FeedDetailsLayout
  },
  list: {
    resultsVariant: 'list'
  },
  form: {
    modal: {
      fill: true
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'taxonomies',
      label: process.env.TAXONOMIES_LABEL || 'Challenges & Goals'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      description: {
        type: 'longText'
      },
      challenges: {
        type: 'linkedMultiple',
        entityTypeName: 'Challenge',
        fieldSet: 'taxonomies'
      },
      keyIssues: {
        type: 'linkedMultiple',
        entityTypeName: 'KeyIssue',
        fieldSet: 'taxonomies'
      },
      trends: {
        type: 'linkedMultiple',
        entityTypeName: 'Trend',
        fieldSet: 'taxonomies'
      },
      topics: {
        type: 'linkedMultiple',
        entityTypeName: 'Topic',
        fieldSet: 'taxonomies'
      },
      subTopics: {
        type: 'linkedMultiple',
        entityTypeName: 'SubTopic',
        fieldSet: 'taxonomies'
      },
      sdgs: {
        type: 'linkedMultiple',
        entityTypeName: 'Sdg',
        fieldSet: 'taxonomies'
      }
    })
  }
};
var templateObject_1;